// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Utils = require("../../../../utils/Utils.bs.js");
var MenuV5 = require("../../../common/Components/menu/MenuV5.bs.js");
var ButtonsV5 = require("../../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Icon__Jsx3 = require("../../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var JsxRuntime = require("react/jsx-runtime");

function DuplicatePropertyError$ViewClientButton(props) {
  return JsxRuntime.jsxs(ButtonsV5.SecondaryButton.make, {
              href: "/my_clients/" + props.clientId,
              size: "small",
              children: [
                JsxRuntime.jsx(Icon__Jsx3.make, {
                      icon: "Client"
                    }),
                Utils.$$String.nbsp + "View Client"
              ]
            });
}

var ViewClientButton = {
  make: DuplicatePropertyError$ViewClientButton
};

function DuplicatePropertyError$ActionsDropdown(props) {
  return JsxRuntime.jsx(MenuV5.Menu.make, {
              button: JsxRuntime.jsxs(ButtonsV5.Button.make, {
                    size: "small",
                    className: "border border-gray-200 text-gray-600 hover:text-white hover:bg-tan-blue-500 hover:border-tan-blue-500",
                    children: [
                      JsxRuntime.jsx(Icon__Jsx3.make, {
                            icon: "ArrowDown"
                          }),
                      Utils.$$String.nbsp + "Actions"
                    ]
                  }),
              children: props.children
            });
}

var ActionsDropdown = {
  make: DuplicatePropertyError$ActionsDropdown
};

exports.ViewClientButton = ViewClientButton;
exports.ActionsDropdown = ActionsDropdown;
/* Utils Not a pure module */
